<template>
    <Sidebar v-if="$store.state.user_data" />
    <Content class="help-content">
        <div class="inner">
            <!-- https://airtable.com/appS5wnRH2HzS6pXd/pagueECRfK3gOCitx/form?prefill_User+Sequential=89281&prefill_User+Alphanumeric=123321" -->
            <iframe v-if="iframe_url" class="airtable-embed" :src="iframe_url" frameborder="0" onmousewheel=""
                width="100%" height="533" style="background: transparent;"></iframe>
        </div>
    </Content>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Content from '@/components/ui/Content.vue';

export default {
    name: 'Help',

    data() {
        return {
            iframe_url: '',
        }
    },

    components: {
        Sidebar,
        Content,
    },

    methods: {
        randomString(len = 6) {
            let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
            let maxPos = $chars.length;
            let pwd = '';
            for (let i = 0; i < len; i++) {
                pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
            }
            return pwd;
        },

        startFunction() {
            let user = this.$store.state.user_data;
            const mid = user && user.merchant_account ? this.randomString() + user.merchant_account.id + this.randomString() : '';
            const userid = user ? this.randomString() + user.id + this.randomString() : '';
            //`https://airtable.com/embed/appS5wnRH2HzS6pXd/pagueECRfK3gOCitx/form?prefill_User+Sequential=${uid}&prefill_User+Alphanumeric=${ukey}`;
            let filed1 = `Anchor+Merchant+ID`;//`Anchor+Merchant+ID`;
            let filed2 = `Portal+User+Sequential+ID`;//`Portal+User+sequential+ID`;
            this.iframe_url = `https://airtable.com/embed/appy9vkRbVQzQiIGx/pagBJQXNNhbcedX39/form?prefill_${filed1}=${mid}&prefill_${filed2}=${userid}&hide_${filed1}=true&hide_${filed2}=true`;
        }
    },

    mounted() {
        this.startFunction();
    },
}
</script>

<style lang="scss">
.help-content {

    .inner {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font: var(--font-fg-24);

        .airtable-embed {
            height: 100%;
            width: 100%;
            border-radius: 16px 0 0;
        }
    }
}
</style>